export default {
  title: 'La tua recensione è preziosa ❤️',
  description: '{{name}} su {{store}} — tocca una stella',
  buttons: {
    not_now: 'Non ora',
    continue: 'Continua',
  },
};
